stimulusApp.register(
  "cruise-departure",
  class extends Stimulus.Controller {
    static targets = ["dates", "datesLink", "cabins", "title", "intro", "party"]
    static outlets = ["cruise-picker"]

    pick(event) {
      const { voyage, title, cabinClass } = event.params

      if (voyage && this.hasCruisePickerOutlet) {
        this.cruisePickerOutlet.choose(voyage, cabinClass)
      }
      this.#title(title)

      if (this.hasDatesTarget) this.datesTarget.classList.add("hidden")
      if (this.hasDatesLinkTarget) this.datesLinkTarget.classList.add("hidden")
      this.partyTargets.forEach((field) => field.classList.remove("hidden"))
      if (this.hasCabinsTarget) Viewport.scrollTo($(this.cabinsTarget))
    }

    preview(event) {
      this.#title(event.detail.title)

      if (event.detail.intro && this.hasIntroTarget) {
        this.introTarget.textContent = event.detail.intro
      }
    }

    #title(text) {
      if (text && this.hasTitleTarget) this.titleTarget.textContent = text
    }
  },
)
